export default function getSuffix(name) {
    switch (name) {
        case 'bijtelling_pct':
            return '%';
        case 'aantal_deuren':
            return ' deuren';
        case 'tellerstand':
            return ' km';
        case 'laadtijd':
            return ' uren';
        case 'snellaadtijd':
            return ' minuten';
        case 'accu_capaciteit':
            return ' kWh accu';
        case 'actieradius_elektrisch':
            return ' km';
        default:
            return '';
    }
}
